import {
  SUCCESS,
  FAIL,
  GET_SYSTEM_AUDIT_LOGS,
  GET_SYSTEM_AUDIT_LOG_BY_ID,
} from "../action_types";

const STATE_INIT = {
  isLoading: false,
  isDetailsLoading: false,
  logs: [],
  logDetails: null,
  pagination: {
    page: 1,
    limit: 50,
    total: 0,
    totalPages: 0,
  },
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_SYSTEM_AUDIT_LOGS:
      return { ...state, isLoading: true };
    case `${GET_SYSTEM_AUDIT_LOGS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        logs: payload?.logs || [],
        pagination: payload?.pagination || state.pagination,
      };
    case `${GET_SYSTEM_AUDIT_LOGS}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case GET_SYSTEM_AUDIT_LOG_BY_ID:
      return { ...state, isDetailsLoading: true };
    case `${GET_SYSTEM_AUDIT_LOG_BY_ID}_${SUCCESS}`:
      return {
        ...state,
        isDetailsLoading: false,
        logDetails: payload,
      };
    case `${GET_SYSTEM_AUDIT_LOG_BY_ID}_${FAIL}`:
      return { ...state, isDetailsLoading: false, error: { ...payload } };

    default:
      return state;
  }
};